export default __webpack_public_path__ + "static/media/product_01.6be97a61.jpg";